import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevelopmentChartComponent } from './development-chart.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BaseChartDirective } from 'ng2-charts';
import { TooltipButtonModule } from '../../tooltip-button/tooltip-button.module';
import { InstrumentChartDropdownModule } from '../instrument-chart-card/instrument-chart-dropdown/instrument-chart-dropdown.module';
import { VideoPreviewModule } from '../../video-preview/video-preview.module';



@NgModule({
  declarations: [
    DevelopmentChartComponent
  ],
  imports: [
    CommonModule,
    InstrumentChartDropdownModule,
    BaseChartDirective,
    TranslateModule,
    TooltipButtonModule,
    VideoPreviewModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    DevelopmentChartComponent
  ]
})
export class DevelopmentChartModule { }
